import {
  MenuElement,
  MenuElementItem,
} from 'frontend-container/components/Menu/types';

import { acConfig } from '@ac/library-utils/dist/declarations';
import { IconName } from '@ac/web-components';

export const customersDashboard: MenuElementItem = {
  link: `${acConfig.newFrontendUrls.configurationv2}/customers`,
  aliases: [acConfig.newFrontendUrls.configurationv2],
  translation: 'MENU.CUSTOMERS.ITEMS.DASHBOARD',
};

export const customersMenuReadOnlyMode: MenuElement = {
  translation: 'MENU.CUSTOMERS.TITLE',
  icon: IconName.profile,
  id: 'menu-organization-structure',
  items: [customersDashboard],
};
export const customersMenuFull: MenuElement = {
  ...customersMenuReadOnlyMode,
  items: [
    ...customersMenuReadOnlyMode.items,
    {
      link: `${acConfig.newFrontendUrls.configurationv2}/customers/new`,
      translation: 'MENU.CUSTOMERS.ITEMS.NEW',
    },
  ],
};
